import "snapsvg-cjs-ts";

export const SnapSVG = {
	install(vue:any, options:any){}
};